import register from '@/lib/directives.mjs';
import { translateNodes } from '@/lib/i18n.mjs';

register((node) => {
  if (node.nodeName !== 'svg') {
    translateNodes(node);
  }
});
